<div class="flex flex-1 flex-col justify-between p-4">
  <ng-container *ngIf="!isLoading && !error; else loadingOrError">
    <div class="mb-4 flex justify-end">
      <button mat-icon-button (click)="refreshNews()" [disabled]="isLoading">
        <div class="flex justify-center">
          <i class="ph-fill ph-arrows-clockwise"></i>
        </div>
      </button>
    </div>
    <div class="mat-body-2">
      <div class="mt-8 flex items-baseline">
        <div class="flex flex-col">
          <span>{{ 'news.status' | translate }}:</span>
          <span>{{ 'news.date' | translate }}:</span>
          <span *ngIf="currentNewsItem?.plannedDowntime">{{ 'news.plannedDowntime' | translate }}:</span>
          <span>{{ 'news.category' | translate }}:</span>
        </div>
        <div class="ml-4 flex flex-1 flex-col">
          <span>{{ currentNewsItem?.status }}</span>
          <span>{{ currentNewsItem?.date }}</span>
          <span *ngIf="currentNewsItem?.plannedDowntime">{{ currentNewsItem?.plannedDowntime }}</span>
          <span>{{ currentNewsItem?.category }}</span>
        </div>
      </div>
    </div>
    <div class="flex items-center justify-between p-4">
      <button (click)="changeNews(currentNewsItemIndex - 1)" class="mat-headline-2 mb-0 text-hk_primary-600 hover:cursor-pointer">
        <i class="ph-fill ph-arrow-fat-left"></i>
      </button>
      <span>Info: {{ currentNewsItemIndex + 1 }} {{ 'news.of' | translate }} {{ news.length }}</span>
      <button (click)="changeNews(currentNewsItemIndex + 1)" class="mat-headline-2 mb-0 text-hk_primary-600 hover:cursor-pointer">
        <i class="ph-fill ph-arrow-fat-right"></i>
      </button>
    </div>
  </ng-container>

  <ng-template #loadingOrError>
    <div class="flex flex-1 items-center justify-center">
      <hk-centered-mat-spinner *ngIf="isLoading"></hk-centered-mat-spinner>
      <span *ngIf="error" class="text-red-500">{{ error }}</span>
    </div>
  </ng-template>
</div>
